import { useTranslation } from 'react-i18next'
// import { useQueryClient } from 'react-query'

import { IconUpcomingLive } from 'assets/svg/sprite'
import { usePreviewContext } from 'context/previewContext'
// import { useEngagePost } from 'helpers/hooks'
// import { pagedPostEngageMutationOptions } from 'helpers/mutationOptions'
import { formatedDate } from 'lib/dayjs'

import { type IProps } from './LivePostWrapper.types'

export const LivePostWrapper = ({ postData, dataQuery, postIndex }: IProps) => {

    const previewData = usePreviewContext()
    const { t } = useTranslation()
    const coverImage =
        postData.photos?.[0]?.thumb_url ??
        postData.photos?.[0]?.url

    const handleWrapperClick = () => {
        if (previewData.minimized) {
            previewData.updateSelectedPost(
                postIndex,
                0,
                'live',
                postData,
                dataQuery
            )
            previewData.handleMinimize(false)
        } else {

            previewData.addModal(postIndex, 0, 'live', postData, dataQuery)
        }
    }

    if (!postData.live_scheduled_at) {
        return null
    }

    return (
        <div className='post-tags-wrapper'>
            <div className='post__files__carousel'>
                <div
                    className={'post__files__file post__files__file--img'}
                    onClick={handleWrapperClick}
                >
                    <img
                        src={coverImage}
                        alt='Live post background'
                    />
                    {postData.live_scheduled_at && (
                    <div className='post__files__file__upcoming'>
                        <IconUpcomingLive />

                        <div className='post__files__file__upcoming__content'>
                            <p>{t('upcomingLiveStream')}</p>

                            <div className='post__files__file__upcoming__date'>
                                {formatedDate(postData.live_scheduled_at, 'MMM D, h:mm A')}
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div>
    )
}
